var uncurryThisRaw = require('../internals/function-uncurry-this-raw');

var toString = uncurryThisRaw({}.toString);
var stringSlice = uncurryThisRaw(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/internals/classof-raw.js
// module id = 2xmP
// module chunks = 04af